// app/javascript/reducers/uiReducer.js
const initialState = {
  isMessageFormMounted: false,
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_MESSAGE_FORM_MOUNTED':
      return { ...state, isMessageFormMounted: action.payload };
    default:
      return state;
  }
}
